<template>
  <widget
    @closed="$emit('closed')"
    title="Retribuzioni annue e trattenute"
    icon="mdi-account-group"
    :bgColor="colors.orange"
    dark
  >
    <v-row no-gutters class="pl-2">
      <v-col cols="12" sm="4" lg="3" xl="2">
        <year-select
          v-model="anno"
          @updated="updateYearData"
          class="text-caption"
        ></year-select>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" md="6" class="px-2">
        <vue-apex-charts
          ref="graf"
          type="bar"
          height="350"
          :options="chartOptions"
          :series="series"
        ></vue-apex-charts>
      </v-col>
      <v-col cols="12" md="6" class="px-2">
        <sea-legend>
          <sea-legend-head>Competenze:</sea-legend-head>
          <v-divider></v-divider>
          <sea-legend-row
            color="#330099"
            label="Retribuzione/compenso"
            viewData
            :value="yearData.stipendio"
          >
          </sea-legend-row>
          <v-divider></v-divider>
          <sea-legend-row
            color="#b0c4de"
            label=" Mensilità aggiuntive"
            viewData
            :value="yearData.mensilitaAggiuntive"
          >
          </sea-legend-row>
          <v-divider></v-divider>
          <sea-legend-head>Trattenute:</sea-legend-head>
          <v-divider></v-divider>
          <sea-legend-row
            color="#ff6633"
            label="Ritenute Irpef"
            viewData
            :value="yearData.ritenuteIrpef"
          >
          </sea-legend-row>
          <v-divider></v-divider>
          <sea-legend-row
            color="#f50e13"
            label="Contributi"
            viewData
            :value="yearData.contributi"
          >
          </sea-legend-row>
          <v-divider></v-divider>
          <sea-legend-row
            color="#ffc90e"
            label="Altre trattenute"
            viewData
            :value="yearData.altreTrattenute"
          >
          </sea-legend-row>
          <v-divider></v-divider>
          <sea-legend-head>Netto:</sea-legend-head>
          <v-divider></v-divider>
          <sea-legend-row
            color="#a0ce17"
            label="Retribuzione netta"
            viewData
            :value="yearData.retribuzioneNetta"
          >
          </sea-legend-row>
        </sea-legend>
      </v-col>
    </v-row>
  </widget>
</template>

<script>
import Widget from "./Widget.vue";
import SeaLegend from "../SeaLegend.vue";
import SeaLegendHead from "../SeaLegendHead.vue";

import SeaLegendRow from "../SeaLegendRow.vue";
import VueApexCharts from "vue-apexcharts";
import mixin from "@/mixin";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "retribuzione-trattenute",
  mixins: [mixin],
  components: {
    VueApexCharts,
    SeaLegend,
    SeaLegendHead,
    SeaLegendRow,
    Widget,
  },
  created() {
    this.anno = new Date().getFullYear();
  },
  mounted() {
    this.fetchYearData({ anno: this.anno });
  },
  data() {
    return {
      anno: null,
      chartOptions: {
        chart: {
          type: "bar",
          height: 350,
          stacked: true,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 0,
          },
        },
        xaxis: {
          type: "category",
          categories: ["Competenze", "Trattenute", "Netto"],
        },
        yaxis: {
          labels: {
            show: true,
            formatter: (val) =>
              new Intl.NumberFormat("it-IT", {
                style: "currency",
                currency: "EUR",
                minimumFractionDigits: 2,
              }).format(val),
          },
        },
        legend: {
          show: false,
        },
        fill: {
          opacity: 1,
          colors: [
            "#330099",
            "#b0c4de",
            "#ff6633",
            "#f50e13",
            "#ffc90e",
            "#a0ce17",
          ],
        },
      },
    };
  },
  methods: {
    ...mapActions({
      fetchYearData: "widget/fetchYearData",
    }),
    updateYearData() {
      this.fetchYearData({ anno: this.anno });
    },
    updateOptions(options) {
      this.$refs.graf.updateOptions(options);
    },
  },
  computed: {
    ...mapGetters({
      yearData: "widget/yearData",
    }),
    series() {
      return [
        {
          name: "Retribuzione/compenso",
          data: [this.yearData.stipendio, 0, 0],
        },
        {
          name: "Mensilità aggiuntive",
          data: [this.yearData.mensilitaAggiuntive, 0, 0],
        },
        {
          name: "Ritenute Irpef",
          data: [0, this.yearData.ritenuteIrpef, 0],
        },
        {
          name: "Contributi",
          data: [0, this.yearData.contributi, 0],
        },
        {
          name: "Altre trattenute",
          data: [0, this.yearData.altreTrattenute, 0],
        },
        {
          name: "Retribuzione netta",
          data: [0, 0, this.yearData.retribuzioneNetta],
        },
      ];
    },
  },
};
</script>

<style>
</style>